import { useEffect } from 'react';

import { useSettingsContext } from 'src/components/settings';

import { ModuleLayout } from '../module/layout';
import { useDivisionNavData } from '../config-nav-dashboard';
import { DivisionInfo } from './division-info';

// ----------------------------------------------------------------------

export type DivisionLayoutProps = {
  children: React.ReactNode;
};

export function DivisionLayout({ children }: DivisionLayoutProps) {
  const settings = useSettingsContext();
  const { divisionNavData } = useDivisionNavData();
  useEffect(() => {
    settings.onUpdateField('navLayout', 'mini');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ModuleLayout data={divisionNavData} navTopComponent={<DivisionInfo />}>
      {children}
    </ModuleLayout>
  );
}
